import Show from '@/components/Studies/Randomization/Show';

export default Show;
